import loanFormModel from '../../form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import { PropertyOwnershipStatusRuleset } from '../../business/ruleset/solar_property';
import * as Yup from 'yup';

const {
  formField: { systemPropertyOwnershipStatus },
} = loanFormModel;

export class PropertyOwnershipStatusValidation implements ValidationSchema {
  public name: string = systemPropertyOwnershipStatus.name;
  public label = '';
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: 'This field is required',
    value: false,
  };
  public nullable = true;
  public ruleset = PropertyOwnershipStatusRuleset;

  public when(schema: Yup.StringSchema, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    if (required) return schema.required('Ownership Status is required');

    return schema;
  }
}
export default new Validation(new PropertyOwnershipStatusValidation());
